import { useAppConfig, useAssignedAppType, useModalApi, usePortalConfig, useToastApi, useTranslations } from '../core';
import { useAnonymousApi } from '../api';
import { ICoreContext } from '@vivli/core/infrastructure/interface';
import { useMemo } from 'react';

export const useCoreInit = (): ICoreContext => {
    const assignedAppType = useAssignedAppType();
    const portalConfig = usePortalConfig();
    const anonApi = useAnonymousApi();
    const config = useAppConfig({ anonApi, assignedAppType: assignedAppType.type, portalConfig });
    const translationsLoaded = useTranslations({ anonApi, assignedAppType: assignedAppType.type });
    const modalApi = useModalApi();
    const toastApi = useToastApi();

    // export core hooks
    return useMemo(
        () => ({
            assignedAppType,
            config,
            modalApi,
            toastApi,
            anonApi,
            translationsLoaded,
            portalConfig
        }),
        [assignedAppType, config, modalApi, toastApi, anonApi, translationsLoaded, portalConfig]
    );
};
